/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const MIME_TYPE = "audio/webm;codecs=opus";

// Backend contract (LB-8333): mono recording with browser-side voice cleanup.
export const AUDIO_CONSTRAINTS: MediaTrackConstraints = {
  channelCount: 1,
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: true,
};
